import { vitePlugin } from './index.ts';

export default vitePlugin;
